import { CheckCircleIcon, ExclamationCircleIcon, InformationCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";
import { useEffect, useState } from "react";
const types = {
    success: {
        icon: CheckCircleIcon,
        bgColor: "bg-green-100/70",
        textColor: "text-green-800",
        iconColor: "text-green-400",
    },
    error: {
        icon: XCircleIcon,
        bgColor: "bg-red-100/70",
        textColor: "text-red-800",
        iconColor: "text-red-800",
    },
    warning: {
        icon: ExclamationCircleIcon,
        bgColor: "bg-yellow-100/70",
        textColor: "text-yellow-800",
        iconColor: "text-yellow-800",
    },
    info: {
        icon: InformationCircleIcon,
        bgColor: "bg-blue-100/70",
        textColor: "text-blue-800",
        iconColor: "text-blue-800",
    },
}
export default function Alert({ type, title, description }) {
    const [currenttype, setCurrentType] = useState(types["info"]);
    useEffect(() => {
        setCurrentType(types[type])
    }, [type])
    return (
        <div className={currenttype.bgColor + " p-4 rounded-xl mb-4"}>
            <div className="flex gap-3">
                <div className="flex-shrink-0">
                    <currenttype.icon className={currenttype.iconColor + " h-5 w-5"} aria-hidden="true" />
                </div>
                <div>
                    {title && <h3 className={currenttype.textColor + " text-sm font-medium"} style={{ whiteSpace: "pre-line" }}>{title}</h3>}
                    <div className={currenttype.textColor + " mt-2 text-sm"} style={{ whiteSpace: "pre-line" }}>
                        {description}
                    </div>
                </div>
            </div>
        </div>
    )
}